import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import config from "./app.config.json";

const options = {
  order: [
    "navigator",
    "querystring",
    "cookie",
    "localStorage",
    "sessionStorage",
    "htmlTag",
  ],
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    load: "currentOnly",
    fallbackLng: "en-US",
    debug: config.environment === "local" || config.environment === "sandbox",
    preload: ["en-US"],
    backend: {
      loadPath: `${config.public_path}/locales/{{lng}}/{{ns}}.json`,
    },
  });

export default i18n;
